<template>
  <div class="requestlistdocs mstablelist">
    <div class="row m-0">
      <div class="w-100">
        <div class="button__header row m-0 justify-content-between">
          <!-- <div>
            <p class="requestlistdocs__header">MSDS DOCUMENT</p>
            <div class="requestlistdocs__file" v-if="custDetail !== 0">
              <img :src="getIconFile(`/${docsMSDS[0].download.fileExt}`)" alt="" height="20px">
              <span class="">{{docsMSDS[0].download.fileCategory}}{{docsMSDS[0].download.fileExt}}</span>
              <img class="imgdownload img__blue" 
                src="@/assets/image/icon/download-blue-medium.svg" alt="" height="22px"
                @click.prevent="downloadDoc(docsMSDS[0].download.shipmentId, docsMSDS[0].download.orderNumber, docsMSDS[0].download.fileCategory,docsMSDS[0].download.fileExt, docsMSDS[0].download.fileId)">
            </div>
            <div v-else class="requestlistdocs__file">
              <i>No Attachment</i>
            </div>
          </div> -->
          <button @click="downloadAllDoc()" :disabled="!items || items.length === 0"
                  :class="custDetail.service_head === 'AIR' ?
                  'button__purplecorporite': custDetail.service_head === 'LAND' ?
                  'button__deepgreen': 'button__bluecorporite'"
                  style="height: fit-content">
            <div v-if="isLoadingDownloadAllDocRL" class="spinner__small--white">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <span v-else>Download All</span>
          </button>
        </div>
        <div class="mstablelist__document mt-4">
          <p class="requestlistdocs__header">DOCUMENTS FROM CHAT</p>
          <b-table
            :class="{'table-purple' : custDetail.service_head === 'AIR'}"
            sticky-header
            no-border-collapse
            responsive
            striped
            :items="items"
            :fields="fields"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                <span v-if="scope.column === 'download'"></span>
                <span v-else>{{ scope.label.toUpperCase() }}</span>
              </div>
            </template>
            <template v-slot:head(download)>
            </template>
            <template v-slot:cell(fileName)="row">
              <div class="text-nowrap">
                <p>{{ row.item.fileName.category }}</p>
                <p>{{ row.item.fileName.desc }}</p>
              </div>
            </template>
            <template v-slot:cell(dateAndTime)="row">
              <div class="text-nowrap">
                <p>{{ row.item.dateAndTime }}</p>
              </div>
            </template>
            <template v-slot:cell(download)="row">
              <div class="text-nowrap">
                <img :src="row.item.download.image"
                    @click.prevent="downloadDoc(row.item.download.shipmentId,
                    row.item.download.orderNumber, row.item.download.fileCategory,
                    row.item.download.fileExt, row.item.download.fileId)">
              </div>
            </template>
            <template v-slot:table-caption v-if="!items || items.length === 0">
              <i>No Attachment</i>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDateTime from '@/mixin/getters/date-time'
import mixinFileExt from '@/mixin/getters/file-extention'

export default {
  name: 'RequestlistDocuments',
  mixins: [mixinDateTime, mixinFileExt],
  props: {
    typeRequest: String,
    custDetail: Object
  },
  data () {
    return {
      checkMSDS: false,
      docsMSDS: [],
      groupDocs: [],
      fields: [
        { key: 'no.' },
        { key: 'fileName' },
        { key: 'dateAndTime' },
        { key: 'download', tdClass: 'download_field' }
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      // rfq docs
      rfqDocs: 'fileRfq/items',
      isLoadingRFQDoc: 'fileRfq/isLoading',
      isErrorRFQDoc: 'fileRfq/error',
      // ctc docs
      contractDocs: 'fileContract/items',
      isLoadingContractDoc: 'fileContract/isLoading',
      isErrorContractDoc: 'fileContract/error',

      isLoadingDownloadAllDocRL: 'requestList/isLoadingDownloadAllDocRL'
    })
  },
  mounted () {
    this.getItems()
  },
  methods: {
    async getItems () {
      return new Promise((resolve) => {
        this.items = []
        this.docsMSDS = []
        const documents = this.custDetail.files
        if (documents) {
          documents.forEach((item, index) => {
            const newItem = {
              no: `${index + 1}.`,
              fileName: { category: item.category, desc: item.description },
              dateAndTime: '-',
              download: {
                image: require('@/assets/image/icon/download-blue-medium.svg'),
                shipmentId: this.$route.params.id_iq,
                orderNumber: this.$route.params.iqNumber,
                fileId: item.id,
                fileCategory: item.category,
                fileExt: item.extension
              }
            }
            if (item.fileCategory !== 'MSDS') {
              this.items.push(newItem)
            } else if (item.fileCategory === 'MSDS') {
              this.docsMSDS.push(newItem)
            }
          })
        }
        return resolve()
      })
    },
    init () {
      if (this.contractDocs) {
        this.docs = this.contractDocs
      }
    },
    downloadDoc (id, orderNumber, fileCategory, fileExt, fileId) {
      const shipmentId = id
      const type = 'INSTANT-REQUEST'
      const fileName = `${fileCategory}${fileExt}`
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {shipmentId, orderNumber: orderNumber.split('/').join('-'), type, fileName, fileCategory, fileId})
    },
    downloadAllDoc () {
      if (!this.isLoadingDownloadAllDocRL) {
        this.$store.dispatch('requestList/DOWNLOAD_ALL_DOC_RL', {
          id: this.$route.params.id_iq,
          requestNumber: this.$route.params.iqNumber,
          requestType: 'INSTANT-REQUEST'
        })
      }
    }
  },
  watch: {
    isUploaded (data) {
      if (data) {
        this.getData()
      }
    },
    custDetail (data) {
      if (data) {
        this.getData()
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/Documents.vue